module.exports = __webpack_public_path__ + "img/es.d7b5d548.png";